import { EcommercePaymentTracker } from './payment';


export const ecommercePaymentTracker: EcommercePaymentTracker = new EcommercePaymentTracker();
export type { TransactionCompleteHandler, TransactionCompletePayload, EcommercePaymentTracker } from './payment';
